<template>
	<div class="row pt-2 pb-2" v-if="services">
		<div class="col-12">
			<transition-group
				appear
				name="staggered-fade"
				tag="div"
				v-bind:css="false"
				v-on:before-enter="beforeEnter"
				v-on:enter="enter"
			>
				<div
					v-for="(service, index) in services"
					:key="service.id"
					v-bind:data-index="index"
					:class="platformActionClass"
					:id="'id-' + service.id"
				>
					<employee-hub-service
						:service-id="service.id"
						:platform-category="platformCategory"
						:current-user-access-token="authResponse.accessToken"
						:env="appEnv"
						class="service-object"
					/>
					<div class="row no-gutters text-right" v-if="services.length > 1">
						<div class="col-12 bg-white pr-md-5 pr-3 pb-4 eh-services-index">
							{{ ++index }} of {{ services.length }} Services
						</div>
					</div>
				<hr class="horizontal-line" v-if="services.length!==index && services.length > 1">
				</div>
			</transition-group>
		</div>
	</div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";
import { mapGetters } from "vuex";
import Velocity from "velocity-animate";
export default {
	name: "DisplayServices",
	computed: {
		...mapGetters(["authResponse"]),
		platformActionClass(){
			return ( this.platformCategory && this.platformCategory === 'IT') ?'mt-5 mb-5':'mb-5';
		}
	},
	props: {
		services: Array,
		platformCategory: String,
		serviceId: String,
	},
	data() {
		return {
			appEnv: CURRENT_ENV
		};
	},
	methods: {
		beforeEnter: function(el) {
			el.style.opacity = 0;
		},
		enter: function(el, done) {
			var delay =
				el.dataset.index *
				(this.serviceId
					? CONSTANTS.DELAY_BETWEEN_MULTI_SERVICE_LOAD_IN_MILLIS_DEEP_LINK_USECASE
					: CONSTANTS.DELAY_BETWEEN_MULTI_SERVICE_LOAD_IN_MILLIS);

			setTimeout(function() {
				Velocity(el, { opacity: 1, height: "100%" }, { complete: done });
			}, delay);
		},
	},
	mounted() {
		this.$nextTick(function() {
			if (this.serviceId) {
				//ScrollTo is not working if the identifier starts with numeric character.
				//Prefixing with id will ensure that scrollTo logic works for deep link usecase.
				this.$scrollTo(`#id-${this.serviceId}`, 800, {
					easing: "linear",
				});
			}
		});
	},
};
</script>

<style scoped>
.eh-services-index {
	font-size: 14px;
	color: #64788d;
}
.horizontal-line{
  border-top: 1px solid #ccc;
}
.service-object :deep(.eh-service-item-panel) {
	padding-left: 0;
}
</style>
<style>
.eh-service-item {
	max-width: none !important;
}
</style>
